import { render, staticRenderFns } from "./campus.vue?vue&type=template&id=8b1f0e38&scoped=true"
import script from "./campus.vue?vue&type=script&lang=js"
export * from "./campus.vue?vue&type=script&lang=js"
import style0 from "./campus.vue?vue&type=style&index=0&id=8b1f0e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1f0e38",
  null
  
)

export default component.exports